export const INPUT_DEBOUNCE_TIME = 400;
export const MAX_INPUT_NUMBER = 1000;
export const MAX_KEYWORD_LENGTH = 80;
export const KEYWORDS_TEMPLATE_DOWNLOAD_URL =
  'https://sf16-sg.tiktokcdn.com/obj/eden-sg/yldxeh7ubqhpquhbf/search_keywords/keywords_template.xlsx';
export const KEYWORDS_USAGE_IMG_URL =
  'https://lf19-ttmp.tiktokstaticb.com/obj/ttastatic-sg/new-user-tutorial/search-keyword-usage.png';
